/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Dialog_DescriptionInputs */

const he_notifications_dialog_description = /** @type {(inputs: Notifications_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בחרו עבור איזה סוג של שינוי מחיר אתם מעוניינים לקבל התראה`)
};

const en_notifications_dialog_description = /** @type {(inputs: Notifications_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose what type of price change you want to be notified about`)
};

/**
* | output |
* | --- |
* | "Choose what type of price change you want to be notified about" |
*
* @param {Notifications_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_dialog_description = /** @type {((inputs?: Notifications_Dialog_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Dialog_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_dialog_description(inputs)
	return en_notifications_dialog_description(inputs)
});